import { cn } from "@/utils/utils";

type FlagProps = {
  countryCode: string;
  disabled?: boolean;
};

type FlagOptionProps = {
  onClick: (country: string) => void;
  countryCode: string;
  label: string;
  phoneNumberCode: string;
  selected: boolean;
  disabled?: boolean;
};

export function Flag(props: FlagProps) {
  return <div className={cn(`fflag ff-md fflag-${props.countryCode} ff-app`,
    props.disabled && "opacity-60"
  )} />;
}

export function FlagOption(props: FlagOptionProps) {
  return (
    <div
      className={cn("flag-option cursor-pointer flex items-center h-24 py-3 hover:bg-[var(--surface-hover)] mx-4 px-8 rounded-xl",
        props.selected ? "border border-[var(--outline-primary-default)] bg-[var(--surface-primary-selected)]" : ""
      )}
      onClick={() => props.onClick(props.countryCode)}
    >
      <Flag countryCode={props.countryCode} disabled={props.disabled} />
      <span className={cn("text-[var(--on-surface-default)]", `country-label ${props.selected ? "selected" : ""}`)}>
        {props.label}
      </span>
      <span className={cn("country-code", "text-[var(--on-surface-default)]")}>(+{props.phoneNumberCode})</span>
    </div>
  );
}
